import type { ProfileStatsDto } from '../domain/contracts'
import type { ProfileStats, StudyStats } from '../domain/profile-stats'

function toStudyStats(stats: ProfileStatsDto['myself']): StudyStats {
  return {
    cardSets: stats.card_groups,
    difficultCards: stats.cards_pause,
    folders: stats.categories,
    masteredCards: stats.cards_done,
    studyingCards: stats.cards_in_progress,
    totalCards: stats.cards_total,
  }
}

export function toProfileStats(dto: ProfileStatsDto): ProfileStats {
  return {
    favorite: toStudyStats(dto.favorite),
    favoriteAccess: {
      allowed: dto.favorite_access.allowed,
      reason: dto.favorite_access.reason,
    },
    mine: toStudyStats(dto.myself),
  }
}
